const tooltip = (events, selector = '.tooltip') => {
    const isTouchable = 'ontouchstart' in document.documentElement;
    const root = document.documentElement || window;
    const clicktouch = ('ontouchstart' in root) ? 'touchstart' : 'click';

    document.querySelectorAll(selector).forEach(el => {
        let sel;
        let panel;
        let offset;
        const clickOut = e => !sel.contains(e.target) && close(()=>{});	
        const btn = el.querySelector('.summary');
        let isClosing = false;

        const keydown = e => {
            !sel.contains(document.activeElement) && close();
            if(e.key === 'Escape'){
                sel.querySelector('.summary').focus(); 
                close();
            }
        }

        const replace = () => {
            const bound = sel.querySelector('.summary').getBoundingClientRect(); 
            const diff = parseInt(window.innerWidth  - (bound.left +bound.width));
            if(window.innerWidth > 768){
                panel.style.transform = diff > 30 ? `translate(${30}px,0)` : `translate(0,0)`;
            }else{
                panel.style.transform =  `translate(${diff  }px,0)`;
            }
        }

        const open = () => { 
            isClosing = true
            sel.querySelector('.summary').setAttribute('aria-expanded', true);
            document.addEventListener('keyup', keydown, false);
            window.addEventListener(clicktouch, clickOut, true);
            events.onopen(sel);
            offset = sel.dataset.offset;
            panel =  sel.querySelector('.panel');
            replace();
        }
        const close = () =>  { 
            isClosing = false;
            sel.querySelector('.summary').setAttribute('aria-expanded', false);
            document.removeEventListener('keyup', keydown);
            window.removeEventListener(clicktouch, clickOut);
        }

        if(!isTouchable) {
            btn.onclick = () => {
                sel = el;
                !isClosing ? open() : close();
            }
		}else{
            btn.onclick = () => {
                sel = el;
                btn.getAttribute('aria-expanded') === 'true' ? close() : open();
            }
        }
	});
}

export default tooltip;